<template>
  <div class="video-player" ref="video-player"></div>
</template>

<script>
import 'xgplayer/dist/index.min.css';
import Player from "xgplayer";
export default {
  name: "VideoPlayer",
  props: {
    src: {
      type: String,
      required: true,
      default: "",
    },
    poster: {
      type: String,
      required: false,
      default: "",
    },
  },
  watch: {
    src(newValue) {
      if (newValue) {
        this.initPlayer();
      }
    },
  },
  mounted() {
    this.$nextTick(this.initPlayer);
  },
  methods: {
    pausePlayer() {
      if (this.player?.paused) {
        return;
      }
      this.player?.pause();
    },
    playPlayer() {
      this.player?.play();
    },
    initPlayer() {
      if (this.player) {
        this.player.destroy?.();
        this.player = null;
      }
      this.player = new Player({
        el: this.$refs["video-player"],
        poster: this.poster,
        url: this.src,
        width: "100%",
        height: "100%",
        playsinline: true,
        ignores: ["time", "fullscreen"],
      });
      ["play"].forEach((evChannel) => {
        this.player.on(evChannel, () => {
          this.$emit("click");
        });
      });
    },
  },
};
</script>

<style lang="scss">
.video-player {
  border-radius: 15px;
  .xgplayer-poster {
    border-radius: 15px;
  }
}
</style>
